import React from 'react'
import Icon from '@jarvis.oddle/core/decorators/Icon'
import { IconInterface } from './IconInterface'

const IconNewPlacedOrder = ({
  className,
  height,
  width,
  fill
}: IconInterface) => {
  return (
    <svg
      className={className}
      width={height}
      height={width}
      viewBox='0 0 100 101'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <rect
        x='0.5'
        y='1'
        width='99'
        height='99'
        rx='15.5'
        fill='white'
        stroke='#D6D6D6'
      />
      <path
        d='M82 50C82 67.6731 67.6731 82 50 82C32.3269 82 18 67.6731 18 50C18 32.3269 32.3269 18 50 18C67.6731 18 82 32.3269 82 50Z'
        stroke='url(#paint0_linear_1340:7284)'
        strokeWidth='4'
      />
      <path
        d='M69.458 36.4678L68.0623 37.8622L69.458 36.4678C67.3672 34.3752 63.9883 34.3343 61.8475 36.3758L44.0231 53.3741L37.5859 47.9312C35.4289 46.1075 32.2211 46.2942 30.2903 48.3559C28.2681 50.5152 28.4034 53.9116 30.591 55.9032L41.8147 66.121C43.1211 67.3103 45.1242 67.289 46.4049 66.0721L69.3566 44.2643C71.5756 42.1558 71.6214 38.6332 69.458 36.4678Z'
        stroke='url(#paint1_linear_1340:7284)'
        strokeWidth='4'
      />
      <defs>
        <linearGradient
          id='paint0_linear_1340:7284'
          x1='29.8267'
          y1='29.1467'
          x2='106.1'
          y2='50.3313'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#0A3040' />
          <stop offset='0.306028' stopColor='#062B58' />
          <stop offset='1' stopColor='#7F50E3' />
        </linearGradient>
        <linearGradient
          id='paint1_linear_1340:7284'
          x1='37.8128'
          y1='41.3'
          x2='81.1737'
          y2='57.7915'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#0A3040' />
          <stop offset='0.306028' stopColor='#062B58' />
          <stop offset='1' stopColor='#7F50E3' />
        </linearGradient>
      </defs>
    </svg>
  )
}

export default Icon(IconNewPlacedOrder)
